import stageConfig from "../stageConfig.json";

const apiUrl = `https://ctt64g6v42.execute-api.us-east-1.amazonaws.com/${stageConfig.stage}`;

async function fetchDownloadUrl(token, filename, bucket, resource) {
  const response = await fetch(`${apiUrl}/${resource}`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file: filename,
      bucket: bucket,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}

export async function getFileDownloadUrl(auth, filepath, bucket, resource) {
  try {
    const token = await auth.getToken();
    const downloadUrl = await fetchDownloadUrl(
      token,
      filepath,
      bucket,
      resource
    );
    return downloadUrl.body;
  } catch (error) {    
    throw error;
  }
}

async function fetchUploadUrl(token, filename, bucket, resource) {
  const response = await fetch(`${apiUrl}/${resource}`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file: filename,
      bucket: bucket,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}

export async function getFileUploadUrl(auth, filepath, bucket, resource) {
  try {
    const token = await auth.getToken();
    const UploadUrl = await fetchUploadUrl(token, filepath, bucket, resource);
    return UploadUrl.body;
  } catch (error) {
    console.error("Could not get file URL", error);
    throw error;
  }
}

/**
 * Fetches multiple signed URLs in a single API call.
 * This reduces latency by avoiding multiple sequential API requests.
 *
 * @param {Object} auth - Auth object with getToken() method
 * @param {Array<string>} filepaths - Array of file paths to get signed URLs for
 * @param {string} bucket - S3 bucket name (default: vecviz-ticker-json)
 * @returns {Object} - Map of filepath to signed URL
 */
export async function getBatchDownloadUrls(auth, filepaths, bucket = "vecviz-ticker-json") {
  try {
    const token = await auth.getToken();
    const response = await fetch(`${apiUrl}/batch-signedurl`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        files: filepaths.map((file) => ({ file, bucket })),
      }),
    });

    const data = await response.json();

    if (data.body?.error) {
      throw Error(data.body.error);
    }

    return data.body;
  } catch (error) {
    console.error("Could not get batch file URLs", error);
    throw error;
  }
}
